package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2025_04_12_Day_3() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Nothing eventful happens during the day. At night, Falorn hears something approaching the camp from the water. He wakes the other heroes. Four Chuul emerge from the water and attack. One of the Chuul is able to grapple Bigglesworth and poisons him. Tuesday frightens two of the Chuul, including the one holding Bigglesworth, and they flee into the pond. Caper flies over the water of the pond to save Bigglesworth. Dirk uses a dimension door to transport himself and Annette to a safe distance. Bigglesworth chops off a Chuul pincer.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Korvis asks a frog where the Chuul came from. The frog thinks they came from underneath the water, possibly an underwater tunnel. The magic wielding heroes think the Chuul may have been drawn to the party by their magical items or possibly their Shield Bearer status.")
    }
}
